// src/app/[locale]/page.tsx
"use client";

import { useAuth } from "@/context/AuthContext";
import { LandingThemeProvider } from "@/context/LandingThemeContext";
import {
  HeroSection,
  ValueBullets,
  ValueProposition,
  HowItWorks,
  Comparison,
  PricingSection,
  LandingFooter,
} from "@/components/landing";
import { FloatingOrbs, GlowCursor } from "@/components/landing/effects";

export default function Home() {
  const { isAuthenticated } = useAuth();
  const isAuth = isAuthenticated();

  return (
    <LandingThemeProvider>
      {/* Background effects */}
      <FloatingOrbs />
      <GlowCursor />

      <main className="min-h-screen relative z-10">
        <HeroSection isAuthenticated={isAuth} />
        <ValueBullets />
        <ValueProposition />
        <HowItWorks />
        <Comparison />
        <PricingSection isAuthenticated={isAuth} />
        <LandingFooter isAuthenticated={isAuth} />
      </main>
    </LandingThemeProvider>
  );
}
